<template lang="pug">
.tiers-product-container(v-if="tiers && tiers.length" :class="{ 'is-embedded': embedded }")
  .tier-product-title(v-if="title") {{ title }}
  .tiers-product
    .line.relative(v-for="group in groupedTiers" :key="`${group.tier}-${group.indices[0]}`")
      shTier(
        :nameProduct="nameProduct"
        :size="size"
        :brand="brand"
        :text="group.tier"
        :quantity="group.quantity"
        :action="action"
        :params="tierParams(group)"
        :disabled="isDisabled(group)"
        :clickable="clickable"
        :enable="enable"
        :tiers="tiers"
        :isChecked="isChecked(group)"
        :reviewedCornerCheck="reviewedCornerCheck"
        @deleted="$emit('deleted', group)"
        @added="$emit('added', group)"
        @enable="$emit('enable', $event)"
      )
</template>

<script>
import { groupTiers } from '@/helpers/tier'
import shTier from '@/components/elements/Tier'

export default {
  name: 'TierList',

  components: { shTier },

  props: {
    tiers: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    nameProduct: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    brand: {
      type: String,
      default: ''
    },
    enable: {
      type: Boolean,
      default: false
    },
    action: {
      type: Function,
      default: () => {}
    },
    buildParams: {
      type: Function,
      default: null
    },
    disabledFn: {
      type: Function,
      default: () => false
    },
    isCheckedFn: {
      type: Function,
      default: () => false
    },
    reviewedCornerCheck: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    groupedTiers () {
      return groupTiers(this.tiers)
    }
  },

  methods: {
    defaultBuildParams (group) {
      return [this.nameProduct, this.size, group.tier, group.indices[0]]
    },

    tierParams (group) {
      if (this.buildParams) return this.buildParams(group)
      return this.defaultBuildParams(group)
    },

    isDisabled (group) {
      return this.disabledFn(group)
    },

    isChecked (group) {
      return this.isCheckedFn(group)
    }
  }
}
</script>

<style lang="stylus">
.tiers-product
  display flex
  flex-wrap wrap
  gap 1rem
  row-gap 1.5em

.tier-product-title
  margin-bottom 1rem
  display flex
  align-items center
  gap .6rem

.tiers-product-container
  border-top 1px solid var(--color-border)
  padding 1rem 0
  margin-top 1rem

.tiers-product-container.is-embedded
  border-top none
  padding 0
  margin-top 0
</style>



// WEBPACK FOOTER //
// src/components/elements/TierList.vue